<template>
    <div class="main-box flex flex-col flex-y-center">
        <img class="search-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/searchs.png" alt="">
        <div class="msg">查找指定的顾客/顾客群</div>
        <div class="cell-box flex flex-y-center flex-between" @click="toSpecifiedSearch">
            <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/customer.png" alt="">
            <div class="title flex-1">要转接的顾客</div>
            <div class="num" v-if="selectedCustomerIds.length>0">{{selectedCustomerIds.length}}位</div>
            <van-icon name="arrow" class="arrow" color="#CCCCCC" />
        </div>
        <div class="cell-box flex flex-y-center flex-between">
            <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/customerBase.png" alt="">
            <div class="title flex-1">要转接的顾客群</div>
            <van-icon name="arrow" class="arrow" color="#CCCCCC" />
        </div>
        <div class="btn" @click="toappointmentInherit">
            确定
        </div>
    </div>
</template>
  
<script>

import request from "@/utils/request";
import { mapState } from 'vuex';


export default {
    name: "specifiedHome",
    data() {
        return {

        };
    },
    computed: {
        ...mapState({
            selectedCustomerIds: (state, getters) => getters.selectedCustomerIds
        })
    },
    methods: {
        //去查找顾客
        toSpecifiedSearch() {
            this.$router.push({ name: "specifiedSearch", query: {} });
        },

        //跳转在职继承页面
        toappointmentInherit() {
            this.$router.push({ name: "appointmentInherit", query: {} });
        }

    },
};
</script>

<style scoped lang="less">
.main-box {
    width: 750px;
    height: 100vh;
    background: #f5f6f7;
    padding: 80px 30px;
}
.search-icon {
    width: 80px;
    height: 80px;
}
.msg {
    font-size: 38px;
    font-weight: 700;
    color: #35434c;
    margin-top: 30px;
    margin-bottom: 80px;
}
.cell-box {
    width: 690px;
    height: 100px;
    background: #ffffff;
    border-radius: 12px;
    padding: 30px 20px;
    margin-bottom: 47px;
    .icon {
        width: 40px;
        height: 40px;
        margin-right: 10px;
    }
    .title {
        font-size: 28px;
        font-weight: 400;
        color: #35434c;
    }
    .num {
        font-size: 28px;
        font-weight: 400;
        color: #a0acb5;
    }
    .arrow {
        font-size: 38px;
    }
}
.btn {
    width: 630px;
    height: 88px;
    background: #333f48;
    border-radius: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    line-height: 88px;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 380px;
}
</style>